import { AdminChannelsScreen } from '@/screens/admin/admin-channels-screen'

export default function () {
  return <AdminChannelsScreen />
}
